export default __webpack_public_path__ + "static/media/banner.10b76d87.png";